<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module class="mb-6" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'date']" />

    <!-- 종사자 정보 -->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>ID(사번)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <EmployeeSelector v-else v-model="form.inputA_1" @select="onSelectEmployee" />
        </div>
        <div>
          <div>생년월일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" readonly />
        </div>
        <div>
          <div>부서</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" readonly />
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <ml-input v-else v-model="form.inputA_4" readonly />
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <ml-input v-else v-model="form.inputA_5" readonly />
        </div>
        <div>
          <div>직급</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <ml-input v-else v-model="form.inputA_6" readonly />
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <ml-input v-else v-model="form.inputA_7" readonly />
        </div>
        <div>
          <div>최종 입사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>
          <ml-input v-else v-model="form.inputA_8" readonly />
        </div>
        <div>
          <div>현보직일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_9 }}</p>
          <ml-input v-else v-model="form.inputA_9" readonly />
        </div>
        <div>
          <div>연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_10 }}</p>
          <ml-input v-else v-model="form.inputA_10" readonly />
        </div>
        <div>
          <div>근속연수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_11 }}</p>
          <ml-input v-else v-model="form.inputA_11" readonly />
        </div>
      </div>
    </div>

    <!-- 설문 문항 -->
    <survey-table class="mb-6" v-model="form.symptomTable" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import moment from "moment";
import SurveyTable from "@/views/boards/single-page/473/SurveyTable.vue";

export default {
  components: {
    SurveyTable,
    EmployeeSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",
        inputA_11: "",

        fileList: [],
        symptomTable: {},
      },
    };
  },
  methods: {
    onSelectEmployee(data) {
      if (!!data.retirement_date) {
        // 퇴사일자가 존재하는 경우
        const hireDate = moment(data.hire_date);
        const retirementDate = moment(data.retirement_date);
        this.form.inputA_11 = retirementDate.diff(hireDate, "days");
      } else {
        const now = moment();
        const hireDate = moment(data.hire_date);
        this.form.inputA_11 = now.diff(hireDate, "days");
      }

      this.form.inputA_0 = data.fields.length > 0 ? data.fields[0].field_name : "";
      this.form.inputA_2 = data.date_of_birth;
      this.form.inputA_3 = data.company.com_name;
      this.form.inputA_4 = data.job_category;
      this.form.inputA_5 = data.employment_type;
      this.form.inputA_6 = data.job_title;
      this.form.inputA_7 = data.full_name;
      this.form.inputA_8 = data.hire_date;
      this.form.inputA_9 = data.current_position_date;
      this.form.inputA_10 = data.contact_number;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
